import { useOutletContext } from 'react-router-dom'

export interface MainOutletContext {
  filterActionsSlot: HTMLElement | null
  priorityFiltersSlot: HTMLElement | null
}

export const useMainOutletContext = () =>
  useOutletContext<MainOutletContext | undefined>()
